import { createColumnHelper } from '@tanstack/react-table';

import { Site } from 'types/site';

const col = createColumnHelper<Site>();

export const buildSiteColumns = () => [
  col.accessor((site) => site?.name || '-', {
    id: 'name',
    header: 'Site Name',
    minSize: 160,
    size: 200,
    meta: { sortField: 'name' },
  }),
  col.accessor(
    (site) => site?.address?.fullAddress || site?.address?.addressLine1 || '-',
    {
      id: 'address',
      header: 'Address',
      minSize: 280,
      size: 520,
    },
  ),
  // The last-activity columns are still placeholders in the page they came
  // from: header and cell both render the literal label.
  col.display({
    id: 'lastDelivery',
    header: 'Last Delivery',
    minSize: 120,
    cell: () => 'Last Delivery',
  }),
  col.display({
    id: 'lastPickup',
    header: 'Last Pickup',
    minSize: 120,
    cell: () => 'Last Pickup',
  }),
  col.display({
    id: 'lastReport',
    header: 'Last Report',
    minSize: 120,
    cell: () => 'Last Report',
  }),
];
